export default __webpack_public_path__ + "static/media/AZ_MRL-1.e879f77c.jpg";